import { notification } from 'antd';
import { useParams } from 'react-router-dom';
import { useCreateRelationItemsMutation, useGetRelationGroupOverviewDetailQuery } from 'services';

import ArticleRelationManagement from './article-relation-management';

function ArticleRelationManagementEdit() {
  const { uid } = useParams();
  const { data } = useGetRelationGroupOverviewDetailQuery({ uid });
  const [createRelationItems] = useCreateRelationItemsMutation();

  const handleSelect = async (option) => {
    const compuiledData = {
      sourceType: data?.type,
      sourceId: data?.originalId,
      targetType: option.article.type,
      targetId: option.article.entryId,
    };
    const { error } = await createRelationItems(compuiledData);
    if (error) {
      return notification.error({
        message: 'Hata',
        description: error.data.violations[0].message,
      });
    }
  };
  return <ArticleRelationManagement onSelect={handleSelect} />;
}

export default ArticleRelationManagementEdit;
